__turbopack_context__.v({
  "bottom": "Image-module-scss-module__h6lcDW__bottom",
  "caption": "Image-module-scss-module__h6lcDW__caption",
  "fade-in": "Image-module-scss-module__h6lcDW__fade-in",
  "flag": "Image-module-scss-module__h6lcDW__flag",
  "free": "Image-module-scss-module__h6lcDW__free",
  "image": "Image-module-scss-module__h6lcDW__image",
  "imageInner": "Image-module-scss-module__h6lcDW__imageInner",
  "isForward": "Image-module-scss-module__h6lcDW__isForward",
  "message": "Image-module-scss-module__h6lcDW__message",
  "middle": "Image-module-scss-module__h6lcDW__middle",
  "prev": "Image-module-scss-module__h6lcDW__prev",
  "root": "Image-module-scss-module__h6lcDW__root",
  "star": "Image-module-scss-module__h6lcDW__star",
  "swipe-off-left": "Image-module-scss-module__h6lcDW__swipe-off-left",
  "swipe-off-right": "Image-module-scss-module__h6lcDW__swipe-off-right",
  "top": "Image-module-scss-module__h6lcDW__top",
  "withCaption": "Image-module-scss-module__h6lcDW__withCaption",
});
